<template>
  <section class="master-page-container">
    <!-- <div>
      <editor
        :init="editorInit"
        v-model="addArticleContent"
      />
    </div> -->
    <froala :tag="'textarea'" :config="config" v-model="content" ref="editS" ></froala>
  </section>
  </template>
  
  <script>
  // 富文本基本文件
  
  import VueFroala from 'vue-froala-wysiwyg';
  import {baseURL} from '../json/common'
  
  export default {
      components:{
          // Editor
      },
      data(){
          var _this = this;
          return{
            config: {
              editor: null,
              lastEditRange: null,
              height: 500,
              language: 'zh_cn',
              // toolbarInline: true,
              toolbarSticky: true,
              // toolbar buttons
              toolbarButtons: [
                'fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', '|', 
                'paragraphFormat', 'fontSize', 'textColor', 'backgroundColor', '|', 
                'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 
                'insertLink', 'insertImage', 'insertTable', '|', 
                'insertHR', 'selectAll', 'clearFormatting', '|', 'html', '|',
                 'undo', 'redo'],
              zIndex: 10000,
              imageEditButtons: ['imageDisplay', 'imageStyle', 'imageSize', 'imageReplace', 'imageAlign', 'imageCaption', 'imageRemove'],
              imageResize: true,
              imageMove: true,
              imageUploadURL: '/food/file/upload',
              imageUploadMethod: 'POST',
              imageMaxSize: 1 * 1024 * 1024,
              imageDefaultWidth: 100,
              imageResizeWithPercent: true,
              imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'bmp'],
              imageDefaultAlign: 'left',
              imageSplitHTML: true,
              events: {
                initialized: (e, editor) => {
                  console.log(this.$refs.editS);
                },
                'froalaEditor.initialized': (e, editor) =>{
                  console.log('initialized')
                  this.editor = editor
                },
                'keyup': (e, editor) =>{
                  const sel = window.getSelection && window.getSelection(); 
                  if (sel && sel.rangeCount > 0) {
                    this.lastEditRange = sel.getRangeAt(0);
                  }
                },
                'image.uploaded': (response) => {
                  // console.log('response', response)
                  const infoParse = response && JSON.parse(response);
                  if(infoParse.code==200){
                    const url = baseURL + infoParse.data
                    const resp = { "link": url }
                    // 插入内容 
                    this.insertImage(url, resp);
                    return false
                  } else {
                    this.$Notice.error({title:'上传出错',desc: infoParse.message});
                  }
                    return false;
                },
                // 'image.beforeUpload': (images) => {
                //   // const infoParse = info.response && JSON.parse(info.response);
                //   console.log('images', images)
                //   let params=new FormData()
                //   params.append('file',images[0])
                //   let config={
                //         headers:{
                //               "Content-Type":"multipart/form-data"
                //         }
                //   }
                //   this.$http.post(`/food/file/upload`,params,config).then(res=>{
                //         if(res.data.code==200){
                //           // // 编辑器获取焦点
                //           // this.editor.events.focus();
                //           // // 获取选定对象
                //           // const selection = getSelection();
                //           // // 判断是否有最后光标对象存在
                //           // if (this.lastEditRange){
                //           //   // 存在最后光标对象，选定对象清除所有光标并添加最后光标还原之前的状态 
                //           //   selection.removeAllRanges();
                //           //   selection.addRange(this.lastEditRange);
                //           // }
                //           const content = '<img src=' + baseURL + res.data.data + ' />'
                //           // 插入内容 
                //           this.insertHtml(content);
                //           // // 插入内容 
                //           // this.editor.html.insert(content);
                //           // // 记录最后光标停留位置
                //           // this.lastEditRange = selection.getRangeAt(0); 
                //         }else{
                //               this.$Notice.error({title:'上传出错',desc: res.data.message});
                //         }
                //   }).catch((err)=>{
                //         this.$Notice.error({title:'上传出错',desc: err.statusText});
                //   })
                // }
              }
            },
            content: '',
          }
      },
      props:{
        editorContent: {
          type: String,
          default: ''
        }
      },
      watch: {
        content: {
          handler() {
            this.$emit('update:editorContent', this.content)
            console.log('监听到数据变化')
          }
        },
        editorContent: {
          handler() {
            this.content = this.editorContent
          },
          immediate: true
        }

      },
      mounted() {
        this.editor = this.$refs.editS.getEditor();
        const sel = window.getSelection && window.getSelection(); 
        if (sel && sel.rangeCount > 0) {
          this.lastEditRange = sel.getRangeAt(0);
        }

      },
      methods:{
        insertImage(img_url, response) {
          this.editor.image.insert(img_url, false, null, this.editor.image.get(), response);
          // //设置编辑器获取焦点
          // this.editor.events.focus();
          // // 获取选定对象
          // const selection = getSelection();
          // // 判断是否有最后光标对象存在
          // if (this.lastEditRange) {
          //   // 存在最后光标对象，选定对象清除所有光标并添加最后光标还原之前的状态
          //   selection.removeAllRanges();
          //   selection.addRange(this.lastEditRange);
          // }
          // //插入内容
          // // this.editor.html.insert(content);
          // this.editor.image.insert(img_url, true, null, this.editor.image.get(), response);
          // //记录最后光标停留位置
          // this.lastEditRange = selection.getRangeAt(0);
        },
  
      }
  }
  </script>
  
  <style lang="postcss" scoped type="scss">



  </style>
  